import { Component, input, inject } from '@angular/core';
import { NgClass } from "@angular/common";

import { AutoAnimateDirective } from "@planmeister/pithos";
import { Router } from "@angular/router";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";

@Component({
    selector: 'app-search-nav-button',
    imports: [
    NgClass,
    AutoAnimateDirective,
    FaIconComponent
],
    templateUrl: './search-nav-button.component.html'
})
export class SearchNavButtonComponent {
    private readonly router = inject(Router);

    readonly colorMode = input<'light' | 'dark'>('light');

    public readonly active = input<boolean>(false);
    public readonly icon = input.required<IconDefinition>();
}
